import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import {
  BEGIN, CREATE, DELETE_BY_ID, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';
import { APPLICANT_MODULE } from '../../configs/moduleNames';

export const LOAD_APPLICANT_LIST = '_LOAD_APPLICANT_LIST';
export const LOAD_APPLICANT_LIST_ALL = '_LOAD_APPLICANT_LIST_ALL';
export const LOAD_APPLICANT_BY_ID = '_LOAD_APPLICANT_BY_ID';
export const EDIT_APPLICANT_BY_ID = '_EDIT_APPLICANT_BY_ID';

export const loadApplicantList = createDeferredAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST);
export const loadApplicantSuccessful = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST + SUCCESSFUL);
export const loadApplicantListFailed = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST + FAILED);
export const loadApplicantListBegin = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST + BEGIN);

export const loadApplicantById = createDeferredAction(APPLICANT_MODULE + LOAD_APPLICANT_BY_ID);
export const loadApplicantByIdSuccessful = createAction(APPLICANT_MODULE + LOAD_APPLICANT_BY_ID + SUCCESSFUL);
export const loadApplicantByIdFailed = createAction(APPLICANT_MODULE + LOAD_APPLICANT_BY_ID + FAILED);

export const deleteApplicant = createDeferredAction(APPLICANT_MODULE + DELETE_BY_ID);
export const deleteApplicantSuccessful = createAction(APPLICANT_MODULE + DELETE_BY_ID + SUCCESSFUL);
export const deleteApplicantFailed = createAction(APPLICANT_MODULE + DELETE_BY_ID + FAILED);

export const createApplicant = createDeferredAction(APPLICANT_MODULE + CREATE);
export const createApplicantSuccessful = createAction(APPLICANT_MODULE + CREATE + SUCCESSFUL);
export const createApplicantFailed = createAction(APPLICANT_MODULE + CREATE + FAILED);

export const editApplicant = createDeferredAction(APPLICANT_MODULE + EDIT_APPLICANT_BY_ID);
export const editApplicantSuccessful = createAction(APPLICANT_MODULE + EDIT_APPLICANT_BY_ID + SUCCESSFUL);
export const editApplicantFailed = createAction(APPLICANT_MODULE + EDIT_APPLICANT_BY_ID + FAILED);

export const loadApplicantListAll = createDeferredAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST_ALL);
export const loadApplicantAllSuccessful = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST_ALL + SUCCESSFUL);
export const loadApplicantAllBegin = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST_ALL + BEGIN);
export const loadApplicantAllFailed = createAction(APPLICANT_MODULE + LOAD_APPLICANT_LIST_ALL + FAILED);
